export default __webpack_public_path__ + "static/media/azeta.fc6a4778.webp";